import { Routes, Route, Navigate } from 'react-router-dom';
import { Section } from '@vnetwork/ui/layout';
import { BillingOverview } from './BillingOverview';
import { InvoiceDetailPage } from './InvoiceDetailPage';

/**
 * Billing area — Phase 2.
 *
 *   /account/billing                       → credits + invoices + transactions
 *   /account/billing/invoices/:invoiceId    → invoice detail + payment
 */
export function BillingPage() {
  return (
    <Routes>
      <Route
        index
        element={
          <Section title="Billing" description="Credit balance, invoices and transactions.">
            <BillingOverview />
          </Section>
        }
      />
      <Route path="invoices/:invoiceId" element={<InvoiceDetailPage />} />
      <Route path="*" element={<Navigate to="/account/billing" replace />} />
    </Routes>
  );
}
